const SvgAi1 = (props) => (
  <>
    <circle cx={192} cy={192} r={192} fill={props.p10} />
  </>
);

export default SvgAi1;
